import React from 'react';
import Compiler from '../compiler/Compiler';

import './style.css';

const KovBlockQuote = ({ item, color }) => {
  return (
    <blockquote className="kov-quote theme-content-blockquote" style={{ color }}>
      <span>
        <Compiler text={item.$$html} />
      </span>
    </blockquote>
  );
};

export default KovBlockQuote;
